import { setIsPaneemTypeSelected } from "../../AppSlice";
import { selectText } from "../LanguageSelect/LanguageSelectSlice";
import { AppRoutes, PaneemType } from "../../constants";
import { useAppDispatch, useAppSelector } from "../../redux";
import { Button, Grid } from "@mui/material";

export default function PaneemTypeSelector() {
  const text = useAppSelector(selectText);

  const dispatch = useAppDispatch();

  return (
    <Grid
      container
      sx={{
        justifyContent: "center",
        padding: 1,
        height: "100%",
      }}
    >
      <Grid
        item
        md={4}
        sm={12}
        sx={{
          mt: "12vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
        }}
      >
        <Button
          sx={{ padding: 2, direction: text.textDirection }}
          variant="contained"
          fullWidth
          color="primary"
          onClick={() => (window.location.href = AppRoutes.authentication)}
        >
          {text.previouslyVerified}
        </Button>

        <Button
          sx={{ padding: 2, direction: text.textDirection }}
          variant="contained"
          fullWidth
          color="secondary"
          onClick={() => dispatch(setIsPaneemTypeSelected(PaneemType.paneem))}
        >
          {text.firstTime}
        </Button>

        <Button
          sx={{ padding: 2, direction: text.textDirection }}
          variant="contained"
          fullWidth
          color="info"
          onClick={() => dispatch(setIsPaneemTypeSelected(PaneemType.statusCheck))}
        >
          {text.statusCheck}
        </Button>
      </Grid>
    </Grid>
  );
}
